const useNumberToWords = () => {
  
  const numberToWords = (num) => {
    const singleDigits = [
      "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"
    ];
    const teens = [
      "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
    ];
    const tens = [
      "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
    ];
    const thousands = [
      "", "Thousand", "Lakh", "Crore"
    ];

    if (num === 0) return "Zero";

    let words = "";

    const numberBelowThousand = (n) => {
      let str = "";

      if (n >= 100) {
        str += singleDigits[Math.floor(n / 100)] + " Hundred ";
        n %= 100;
      }

      if (n >= 10 && n < 20) {
        str += teens[n - 10] + " ";
      } else if (n >= 20 || n === 10) {
        str += tens[Math.floor(n / 10)] + " ";
        n %= 10;
      }

      if (n > 0 && n < 10) {
        str += singleDigits[n] + " ";
      }

      return str.trim();
    };

    let digitGroupIndex = 0;

    while (num > 0) {
      if (num % 1000 !== 0) {
        words = numberBelowThousand(num % 1000) + " " + thousands[digitGroupIndex] + " " + words;
      }
      num = Math.floor(num / 1000);
      digitGroupIndex++;
    }

    return words.trim() + " Rupees only/-";
  };

  return { numberToWords };
};

export default useNumberToWords;
